import TipoDespesaNova from './TipoDespesaNova';

export default TipoDespesaNova;